var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDebugIssues = function SvgDebugIssues(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81,
    height: 81,
    fill: "none",
    viewBox: "0 0 81 81"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M63.832 12.426a100 100 0 0 0-.078-3.469c-.121-3.003-2.151-5.68-5.465-5.88A47 47 0 0 0 55.5 3c-1.08 0-2.003.03-2.789.077-3.314.2-5.344 2.877-5.465 5.88-.029.73-.053 1.552-.067 2.454a281 281 0 0 0-6.679-.078q-3.537.002-6.679.078a99 99 0 0 0-.067-2.454c-.121-3.003-2.151-5.68-5.465-5.88A47 47 0 0 0 25.5 3c-1.08 0-2.003.03-2.789.077-3.314.2-5.344 2.877-5.465 5.88-.04.996-.07 2.163-.078 3.47-1.333.14-2.525.285-3.58.425-4.77.636-8.447 4.257-9.131 9.03C3.762 26.736 3 34.395 3 44.668s.762 17.932 1.457 22.784c.684 4.773 4.362 8.394 9.131 9.03C18.92 77.19 40.5 78 40.5 78s21.58-.808 26.912-1.52c4.769-.635 8.447-4.256 9.131-9.03C77.238 62.6 78 54.94 78 44.668s-.761-17.932-1.457-22.784c-.684-4.774-4.362-8.395-9.132-9.03q-1.58-.213-3.58-.427",
    clipRule: "evenodd",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M38.024 26.888c-9.205 0-16.667 7.462-16.667 16.667 0 9.204 7.462 16.666 16.667 16.666a16.6 16.6 0 0 0 9.191-2.761l6.369 6.368a3.333 3.333 0 1 0 4.714-4.714l-6.369-6.368a16.6 16.6 0 0 0 2.762-9.191c0-9.205-7.462-16.667-16.667-16.667m-10 16.667c0-5.523 4.477-10 10-10s10 4.477 10 10-4.477 10-10 10-10-4.478-10-10",
    clipRule: "evenodd"
  })));
};
export default SvgDebugIssues;